<template>
    <section class="section pb-0 section-components">

        <div class="container mb-5">
            <!-- Inputs -->
            <h3 class="h4 text-success font-weight-bold mb-4">Personal Information</h3>
                <div class="mb-3">
                    <small class="mutted"></small>
                </div>
            <div class="row">
                <div class="col-lg-6">
                    <base-input label="Name" @keyup="validateName" :valid="valid.name" :error="error.name" ref="name" required v-model="application.name"></base-input>
                </div>
                <div class="col-lg-6">
                    <base-input  label="Surname"   @keyup="validateSurname" :valid="valid.surname" :error="error.surname" ref="surname" required v-model="application.surname"> </base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <base-input label="Email address" ref="email" @keyup="validateEmail"  :valid="valid.email" :error="error.email" required v-model="application.email"></base-input>
                </div>
                <div class="col-lg-6">
                    <base-input label="Telephone (include  country code)"  v-model="application.phone"> </base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
									<label class="my-2" >Location</label>

									<base-radio 
										:name="location"  
										value="" 
										class="mb-3" 
										:key="location.id" 
										v-for="location in metadata.locations" 
										v-model="application.workLocation" 
									>
									{{location}}
									</base-radio>
								</div>
            </div>
            <div class="row ">
                <div class="col-12 my-2">
								<label class="my-2">Contract options</label>
								</div>
                <div class="col-12 my-2">
                    <base-checkbox v-model="application.remote">You are able to work from home (remotely)</base-checkbox>
								</div>
                <div class="col-12 my-2">
                    <base-checkbox v-model="application.workFromOffice">You are able to work from our office in your area</base-checkbox>
								</div>
                <div class="col-12 my-2">
                    <base-checkbox v-model="application.workOnContract">You are able to work on a temporary contract basis</base-checkbox>
								</div>
                <div class="col-12 my-2">
                    <base-checkbox v-model="application.workOnPerm">You are able to work on a permanent contract basis</base-checkbox>
								</div>
                <div class="col-12 my-2">
                    <base-checkbox v-model="application.wokrTrips">You are able to travel abroad for a few days if required</base-checkbox>
                </div>
						</div>
        </div>
				

            <h3 class="h4 text-success font-weight-bold mb-4">Skills and Experience</h3>
        <div class="py-5 bg-secondary">
            <div class="container">
                <!-- Inputs (alternative) -->
                <div class="mb-3">
                    <small class="text-uppercase font-weight-bold">List your skills and describe your proficiency</small>
                </div>
                <div class="row">
                    <div class="col-12">
											<textarea class="form-control" id="exampleFormControlTextarea1" rows="10" placeholder="Describe your skills here..." v-model="application.skills"></textarea>
                    </div>
                </div>
                <div class="my-3">
                    <small class="text-uppercase font-weight-bold">Describe your experience</small>
                </div>
                <div class="row">
                    <div class="col-12">
											<textarea class="form-control" id="exampleFormControlTextarea1" rows="10" placeholder="Describe your experience here..." v-model="application.experience"></textarea>

                    </div>
                </div>
            </div>
        </div>
					<a href="#"  id="submit-button" class="btn btn-primary" @click.prevent="submitApplication">Apply for the job</a>
					<base-alert type="danger" v-if="error.submit">
							<strong>You haven't filled all required fields</strong> Please fill all the fields and try again
					</base-alert>
    </section>
</template>
<script>
import BaseRadio from "../../components/BaseRadio";
import axios from 'axios';
export default {
	components:{
		BaseRadio,
	},
	data() {
		return {
			application: {
				name: "",
				surname: "",
				email: "",
				phone: "",
				workLocation: "",
				workRemotely: false,
				workFromOffice: false,
				workOnContract: false,
				workOnPerm: false,
				wokrTrips: false,
				skills: "",
				experience: "",
			},
			valid: {
				name: null,
				surname: null,
				email: null,
			},
			error: {
				name: null,
				surname: null,
				email: null,
				submit: false,
			},
		}
	},
	props: {
		"metadata": Object,
	},
	methods: {
		validateName: function() {
			var valid = true
			if( this.application.name.trim() ==="") {
				this.valid.name = false;
				this.error.name = "You must enter your name"
				valid = false;
			} else {
				this.valid.name = true;
				this.error.name = ""
				valid = true;
			}					
			return valid;
		},
		validateSurname: function() {
			var valid = true
			if( this.application.surname.trim() ==="") {
				this.valid.surname = false;
				this.error.surname = "You must enter your surname"
				valid = false;
			} else {
				this.valid.surname = true;
				this.error.surname = ""
				valid = true;
			}					
			return valid;
		},
		validateEmail: function() {
			var valid = true
			if( this.application.email.trim() ==="") {
				this.valid.email = false;
				this.error.email = "You must enter your email"
				valid = false;
			} else {
				this.valid.email = true;
				this.error.email = ""
				valid = true;
			}					
			return valid;
		},
		checkAllValidations: function () {
			var validkeys = Object.keys(this.valid);
			for (var i = 0 ; i < validkeys.length; i++) {
				if (!this.valid[validkeys[i]] || this.valid[validkeys[i]] == null) {
					this.error.submit = true;
					return false;	
				}
			}
			this.error.submit=false;
			return true;
		},
		submitApplication: function() {
			var valid = this.checkAllValidations()
			if (valid) {
				this.$router.push({ 
					name: "thank_you_for_contacting",
					params: { messageType: "job_application", message: this.application},
				});
			}
		},
	},
};
</script>
<style>
	.has-danger::after,
	.has-success::after {
		top:37px !important;
	}
</style>
